import * as React from 'react';
import {
    Edit,
    required,
    SimpleForm,
    TextInput,
    SelectInput,
    ReferenceInput,
    FormDataConsumer,
} from 'react-admin';
import ResourceTitle from './ResourceTitle';
import ResourceTypesInput from './ResourceTypesInput';

const ResourceEdit = props => (
    <Edit title={<ResourceTitle />} {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="slug" />
            <ReferenceInput label="Environment" source="environment_id" reference="environments">
                <SelectInput source="name" />
            </ReferenceInput>
            <ResourceTypesInput source="type" validate={required()} />

            {/* <ReferenceInput label="Azure storage" source="azure_storage_id" reference="azure_storages">
                <SelectInput source="account_name" />
            </ReferenceInput>
            <ReferenceInput label="Database Item" source="database_item_id" reference="database_items">
                <SelectInput source="hostname" />
            </ReferenceInput>
            <TextInput source="group_name" />
            <ReferenceInput label="Azure auth" source="azure_authentication_id" reference="azure_authentications">
                <SelectInput source="client_id" />
            </ReferenceInput> */}

            <FormDataConsumer>
                {({ formData, ...rest }) => {
                    if (formData.type === "azure_storage") {
                        return (
                            <ReferenceInput label="Azure storage" source="azure_storage_id" reference="azure_storages">
                                <SelectInput optionText="account_name" optionValue="id" allowEmpty />
                            </ReferenceInput>
                        );
                    } else if (formData.type === "mysql" || formData.type === "postgres") {
                        return (
                            <ReferenceInput label="Database Item" source="database_item_id" reference="database_items">
                                <SelectInput optionText="hostname" optionValue="id" allowEmpty />
                            </ReferenceInput>
                        );
                    } else if (formData.type === "azure_sql") {
                        return (
                            <>
                            <ReferenceInput label="Database Item" source="database_item_id" reference="database_items">
                                <SelectInput optionText="hostname" optionValue="id" allowEmpty />
                            </ReferenceInput>
                            <TextInput source="group_name" />
                            <ReferenceInput label="Azure auth" source="azure_authentication_id" reference="azure_authentications">
                                <SelectInput optionText="name" optionValue="id" allowEmpty />
                            </ReferenceInput>
                            </>
                        );
                    } else if (formData.type === "azure_appservice") {
                        return (
                            <ReferenceInput label="Azure auth" source="azure_authentication_id" reference="azure_authentications">
                                <SelectInput optionText="name" optionValue="id" allowEmpty />
                            </ReferenceInput>            
                        );
                    }
                }}
            </FormDataConsumer>


        </SimpleForm>
    </Edit>
);

export default ResourceEdit;